import { render, staticRenderFns } from "./CustomRemarkItem.vue?vue&type=template&id=645b75aa"
import script from "./CustomRemarkItem.vue?vue&type=script&lang=js"
export * from "./CustomRemarkItem.vue?vue&type=script&lang=js"
import style0 from "./CustomRemarkItem.vue?vue&type=style&index=0&id=645b75aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports